import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AnimatedHero from "./AnimatedClayHero";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { useLanguage } from "../../context/LanguageContext";
import { useTheme } from "../../context/ThemeContext";

function Home() {
  const { t } = useLanguage();
  const { theme } = useTheme();

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                {t.home.greeting}{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                {t.home.intro}
                <strong className="main-name"> Dang Ngoc Tien</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20, textAlign: "center" }}>
              <AnimatedHero theme={theme} />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
